/*import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";*/

export default function Contact() {
  return null; // page intentionally blank (no contact form rendered)
}

/* ---- ORIGINAL BELOW ----

export default function Contact() {
  const { t, i18n } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: "", msg: "" });

  // set once on mount for the time-gate
  const tsRef = useRef(null);
  useEffect(() => {
    if (tsRef.current == null) tsRef.current = Date.now();
  }, []);

  // auto-clear status after 2s
  useEffect(() => {
    if (!status.msg) return;
    const id = setTimeout(() => setStatus({ type: "", msg: "" }), 2000);
    return () => clearTimeout(id);
  }, [status.msg]);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    coverLetter: "",
    cv: null,
    recommendations: null,
  });

  const validate = () => {
    if (!form.name.trim()) return t("contact.errors.name_required");
    if (!form.email.trim()) return t("contact.errors.email_required");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      return t("contact.errors.email_invalid");
    if (!form.phone.trim()) return t("contact.errors.phone_required");
    if (!form.country.trim()) return t("contact.errors.country_required");
    if (!form.cv) return t("contact.errors.cv_required");
    const max = 10 * 1024 * 1024;
    if (form.cv && form.cv.size > max) return t("contact.errors.cv_too_big");
    if (form.recommendations && form.recommendations.size > max)
      return t("contact.errors.rec_too_big");
    return "";
  };

  const onFile = (key) => (e) => {
    const file = e.target.files?.[0] || null;
    setForm((f) => ({ ...f, [key]: file }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", msg: "" });
    const err = validate();
    if (err) {
      setStatus({ type: "error", msg: err });
      return;
    }

    const data = new FormData();
    data.append("name", form.name);
    data.append("email", form.email);
    data.append("phone", form.phone);
    data.append("country", form.country);
    data.append("coverLetter", form.coverLetter);
    if (form.cv) data.append("cv", form.cv);
    if (form.recommendations)
      data.append("recommendations", form.recommendations);

    // pass UI language to backend for localized emails
    const uiLang = (i18n.language || navigator.language || "en")
      .slice(0, 2)
      .toLowerCase();
    data.append("locale", uiLang);

    // anti-spam fields expected by backend
    data.append("_ts", String(tsRef.current)); // time-gate
    data.append("website", ""); // honeypot (must be empty)

    setSubmitting(true);
    try {
      // CRA dev proxy (see package.json below) forwards /api to http://localhost:8787
      const res = await fetch("/api/contact", { method: "POST", body: data });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json?.error || t("contact.errors.generic"));
      setStatus({ type: "success", msg: t("contact.status.success") });
      setForm({
        name: "",
        email: "",
        phone: "",
        country: "",
        coverLetter: "",
        cv: null,
        recommendations: null,
      });
      document.getElementById("cv-input")?.value &&
        (document.getElementById("cv-input").value = "");
      document.getElementById("rec-input")?.value &&
        (document.getElementById("rec-input").value = "");
      tsRef.current = Date.now(); // refresh for a future submit
    } catch (err) {
      setStatus({ type: "error", msg: err.message });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="max-w-5xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-extrabold">{t("contact.title")}</h1>
      <p className="text-muted mt-2">{t("contact.intro")}</p>

      <form className="grid md:grid-cols-2 gap-4 mt-6" onSubmit={onSubmit}>
        {/* Name 
        <div className="rounded-2xl border border-neutral-800 p-4">
          <label className="text-sm">{t("contact.fields.name")} *</label>
          <input
            className="mt-2 w-full px-3 py-2 rounded-lg border border-neutral-700 bg-transparent text-white outline-none"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder={t("contact.placeholders.name")}
            required
          />
        </div>

        {/* Email 
        <div className="rounded-2xl border border-neutral-800 p-4">
          <label className="text-sm">{t("contact.fields.email")} *</label>
          <input
            className="mt-2 w-full px-3 py-2 rounded-lg border border-neutral-700 bg-transparent text-white outline-none"
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder={t("contact.placeholders.email")}
            required
          />
        </div>

        {/* Phone 
        <div className="rounded-2xl border border-neutral-800 p-4">
          <label className="text-sm">{t("contact.fields.phone")} *</label>
          <input
            className="mt-2 w-full px-3 py-2 rounded-lg border border-neutral-700 bg-transparent text-white outline-none"
            type="tel"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            placeholder={t("contact.placeholders.phone")}
            required
          />
        </div>

        {/* Country 
        <div className="rounded-2xl border border-neutral-800 p-4">
          <label className="text-sm">{t("contact.fields.country")} *</label>
          <input
            className="mt-2 w-full px-3 py-2 rounded-lg border border-neutral-700 bg-transparent text-white outline-none"
            value={form.country}
            onChange={(e) => setForm({ ...form, country: e.target.value })}
            placeholder={t("contact.placeholders.country")}
            required
          />
        </div>

        {/* CV (required) 
        <div className="md:col-span-2 rounded-2xl border border-neutral-800 p-4">
          <label className="text-sm">{t("contact.fields.cv")} *</label>
          <input
            id="cv-input"
            className="mt-2 w-full px-3 py-2 rounded-lg border border-neutral-700 bg-transparent text-white outline-none file:mr-3 file:px-4 file:py-2 file:rounded-lg file:border-0 file:bg-neutral-200 file:text-black"
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={onFile("cv")}
            required
          />
        </div>

        {/* Recommendations (optional) 
        <div className="md:col-span-2 rounded-2xl border border-neutral-800 p-4">
          <label className="text-sm">
            {t("contact.fields.recommendations_optional")}
          </label>
          <input
            id="rec-input"
            className="mt-2 w-full px-3 py-2 rounded-lg border border-neutral-700 bg-transparent text-white outline-none file:mr-3 file:px-4 file:py-2 file:rounded-lg file:border-0 file:bg-neutral-200 file:text-black"
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={onFile("recommendations")}
          />
        </div>

        {/* Cover Letter (optional) 
        <div className="md:col-span-2 rounded-2xl border border-neutral-800 p-4">
          <label className="text-sm">
            {t("contact.fields.cover_letter_optional")}
          </label>
          <textarea
            className="mt-2 w-full min-h-[140px] px-3 py-2 rounded-lg border border-neutral-700 bg-transparent text-white outline-none"
            value={form.coverLetter}
            onChange={(e) => setForm({ ...form, coverLetter: e.target.value })}
            placeholder={t("contact.placeholders.cover_letter")}
          />
        </div>

        {/* Submit 
        <div className="md:col-span-2 flex items-center gap-4">
          <button
            className="px-5 py-3 rounded-full bg-white text-black font-bold disabled:opacity-60"
            type="submit"
            disabled={submitting}
          >
            {submitting ? t("contact.status.sending") : t("contact.send")}
          </button>
          {status.msg && (
            <span
              className={
                status.type === "error" ? "text-red-400" : "text-green-400"
              }
            >
              {status.msg}
            </span>
          )}
        </div>
      </form>

      <div className="grid md:grid-cols-3 gap-4 mt-6">
        <div className="rounded-2xl border border-neutral-800 p-4">
          <strong className="block">{t("contact.hq")}</strong>
          <p className="text-muted">Bucharest, Romania</p>
        </div>
        <div className="rounded-2xl border border-neutral-800 p-4">
          <strong className="block">{t("contact.email_us")}</strong>
          <p>
            <a className="underline" href="mailto:hello@2getters.com">
              hello@2getters.com
            </a>
          </p>
        </div>
        <div className="rounded-2xl border border-neutral-800 p-4">
          <strong className="block">LinkedIn</strong>
          <p>
            <a
              className="underline"
              href="https://www.linkedin.com/company/2getters"
              target="_blank"
              rel="noreferrer"
            >
              linkedin.com/company/2getters
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
---- END ORIGINAL ---- */